import { render } from "./AdvertisementListTable.vue?vue&type=template&id=50e0b281"
import script from "./AdvertisementListTable.vue?vue&type=script&lang=js"
export * from "./AdvertisementListTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__